import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';

import { LOGOUT_SUCCESS } from './auth/types';

import activitiesReducer from './activities/reducer';
import authReducer from './auth/reducer';
import casesReducer from './cases/reducer';
import companyReducer from './company/reducer';
import dashboardReducer from './dashboard/reducer';
import documentsReducer from './documents/reducer';
import entityProfileReducer from './entityProfile/reducer';
import faqsReducer from './faqs/reducer';
import featureFlagsReducer from './featureFlags/reducer';
import fundingMatchReducer from './fundingMatch/reducer';
import fundingEnquiryReducer from './fundingEnquiry/reducer';
import fundingReportReducer from './fundingReport/reducer';
import fundingSearchProfileReducer from './fundingSearchProfile/reducer';
import fundingSearchReducer from './fundingSearch/reducer';
import i18nReducer from './i18n/reducer';
import inviteReducer from './invite/reducer';
import leadReducer from './lead/reducer';
import learningReducer from './learning/reducer';
import membershipReducer from './membership/reducer';
import modalReducer from './modal/reducer';
import monitorReducer from './monitor/reducer';
import notificationsReducer from './notifications/reducer';
import notifyReducer from './notify/reducer';
import postcoderReducer from './postcoder/reducer';
import teamsReducer from './teams/reducer';
import teamsWizzardReducer from './teamsWizzard/reducer';
import userReducer from './user/reducer';
import lenderReducer from './lender/reducer';
import userReportReducer from './userReport/reducer';
import requestHelpReducersObject from './requestHelp/reducer';

export function rootReducer(history) {
  const appReducer = combineReducers({
    activities: activitiesReducer,
    auth: authReducer,
    cases: casesReducer,
    company: companyReducer,
    dashboard: dashboardReducer,
    documents: documentsReducer,
    entityProfile: entityProfileReducer,
    faqs: faqsReducer,
    featureFlags: featureFlagsReducer,
    fundingMatch: fundingMatchReducer,
    fundingEnquiry: fundingEnquiryReducer,
    fundingReport: fundingReportReducer,
    fundingSearch: fundingSearchReducer,
    fundingSearchProfile: fundingSearchProfileReducer,
    invite: inviteReducer,
    language: i18nReducer,
    lead: leadReducer,
    learning: learningReducer,
    me: userReducer,
    lender: lenderReducer,
    membership: membershipReducer,
    modal: modalReducer,
    monitor: monitorReducer,
    notifications: notificationsReducer,
    notify: notifyReducer,
    postcoder: postcoderReducer,
    router: connectRouter(history),
    teams: teamsReducer,
    teamsWizzard: teamsWizzardReducer,
    userReport: userReportReducer,
    requestHelp: requestHelpReducersObject,
  });

  return (state, action) => appReducer(action.type === LOGOUT_SUCCESS ? undefined : state, action);
}
